angular
    .module('WizApp')
    .component('facebookConnect', {
        controller: [
            '$scope',
            'SyncService',
            'EVENT_NAMES',
            'CookiesConsentService',
            function ($scope, SyncService, EVENT_NAMES, CookiesConsentService) {
                const vm = this;

                vm.isLoading = false;
                vm.facebookConsent = true;

                vm.open = SyncService.getOpener('signup', 'facebook');

                vm.showCookieActivator = showCookieActivator;
                vm.getConsent = getConsent;
                vm.handleClick = handleClick;

                SyncService
                    .on('facebook', 'signup', false, true)
                    .start(() => {
                        vm.isLoading = true;
                        $scope.$emit(EVENT_NAMES.facebookConnect.start);
                    })
                    .success(() => {
                        $scope.$emit(EVENT_NAMES.facebookConnect.success);
                    })
                    .error((type, action, callbacks, response) => {
                        $scope.$emit(
                            response.mail_status === 'ERROR_MAIL_MISSING'
                                ? EVENT_NAMES.facebookConnect.missingEmail
                                : EVENT_NAMES.facebookConnect.error
                        );
                    })
                    .always(() => {
                        vm.isLoading = false;
                    })
                ;

                function showCookieActivator() {
                    $scope.$emit(EVENT_NAMES.facebookConnect.cookieActivator);
                }

                function getConsent() {
                    return CookiesConsentService.getCookiesConsent();
                }

                function handleClick() {
                    vm.getConsent().then(data => {
                        return data.connect_facebook ? vm.open() : vm.showCookieActivator();
                    });
                }
            },
        ],
        // language=HTML
        template:
        `
            <div>
                <button
                    type="button"
                    class="button button--block button--facebook"
                    data-ng-click="$ctrl.handleClick()"
                    data-ng-disabled="$ctrl.isLoading"
                >
                    <img
                        src="/bundles/wizbiicore/images/v35/logo-bt-facebook.svg"
                        alt=""
                        height="18"
                        width="18"
                        class="v-align-text-top margin-right-inner"
                    />
                    {[:: 'wizbii.registerlayer.messages.form.facebooklogin' | trans ]}
                </button>
            </div>
        `,
    });
